import React from 'react';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from './HelperText';

export default class TextInput extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('props', this.props);
		const {
			icon,
			style,
			placeholder,
			name,
			value,
			onChange,
			helperText,
			fieldErrors,
			readOnly = false
		} = this.props;

		return (
			<div className="row">
				<div className="col-sm-12">
					<div className="TextInput">
						<span
							className={icon}
							style={{ fontSize: 16, top: 10, left: 13 }}
						/>
						<input
							type="text"
							autoCapitalize="off"
							className={icon ? 'has-icon' : ''}
							style={style}
							placeholder={placeholder}
							name={name}
							value={value || ''}
							onChange={onChange}
							readOnly={readOnly}
						/>
					</div>
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : (
						<HelperText>{helperText}</HelperText>
					)}
				</div>
			</div>
		);
	}
}
